export const toBase64 = (str: string | undefined) => {
  if (!str) {
    return ''
  }
  return btoa(encodeURIComponent(str))
}

export const fromBase64 = (base64: string | undefined) => {
  if (!base64) {
    return ''
  }
  return decodeURIComponent(atob(base64))
}
